<div>
  <div class="header-style">
    <div class="total-number">
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageIndex]="pageNumber - 1" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30, 100]" (page)="handlePage($event)"></mat-paginator>
      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field>
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input data-testid="subscriptions_search_input" i18n-placeholder="@@searchPlaceholder" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon class="cursor search-icon" data-testid="subscription_clear_button" matSuffix (click)="clearSearch()" i18n-label="@@clearSearch" aria-label="Clear Search">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="subscriptions_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-label="@@searchSubscriptions" aria-label="Search Subscriptions"></mat-icon>
    </div>
  </div>
  <div class="cards-container">
    @for (item of subscriptionsList; track item; let itemIndex = $index) {
      <mat-card class="tall-box card">
        <mat-card-content>
          <img class="cursor" [src]="item.company.logo" (error)="onImgError($event)" i18n-alt="@@companyLogo" alt="Company Logo">
          <div class="content-box ">
            <div class="flex-grow cursor">
              <div class="mat-subtitle-1 margin-bottom" matTooltip ellipsisTooltip>{{truncateName(item.subscriber.businessName, '')}}</div>
              <div i18n="@@approved" class="mat-caption mb-8">Approved</div>
            </div>
            <mat-icon data-testid="delete_subscription_button" (click)="deleteSubscription(item.company.id)" color="warn" class="cursor" i18n-label="@@deleteSubscription" aria-label="Delete Subscription">delete_outline</mat-icon>
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (subscriptionsList.length === 0) {
      <img 
        class="empty-view-img" 
        src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" 
        alt="No subscriptions available"
        i18n-alt="@@emptySubscriptionsImageAlt"
      >
    }
  </div>
</div>